import React, { createContext, useContext, useReducer } from "react";
import { initialState, estoquesMedicamentoReducer, EstoquesMedicamentoState } from "./estoques-medicamento-reducer";

type EstoquesMedicamentoContextType = {
    state: EstoquesMedicamentoState;
    dispatch: React.Dispatch<any>;
};

const EstoquesMedicamentoContext = createContext<EstoquesMedicamentoContextType | undefined>(undefined);

export const EstoquesMedicamentoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(estoquesMedicamentoReducer, initialState);

    return (
        <EstoquesMedicamentoContext.Provider value={{ state, dispatch }}>
            {children}
        </EstoquesMedicamentoContext.Provider>
    );
};

export const useEstoquesMedicamentoState = () => {
    const context = useContext(EstoquesMedicamentoContext);
    if (!context) {
        throw new Error("useEstoquesMedicamentoState must be used within EstoquesMedicamentoProvider");
    }
    return context.state;
};

export const useEstoquesMedicamentoDispatch = () => {
    const context = useContext(EstoquesMedicamentoContext);
    if (!context) {
        throw new Error("useEstoquesMedicamentoDispatch must be used within EstoquesMedicamentoProvider");
    }
    return context.dispatch;
};
